module.exports = __webpack_public_path__ + "static/media/calculate-04.27665418.svg";